import useAuth from "@app/hooks/use-auth.ts";
import LogoutIcon from "@mui/icons-material/Logout";
import PasswordIcon from "@mui/icons-material/Password";
import PersonIcon from "@mui/icons-material/Person";
import { NavItem } from "bi-lib";
import { useMemo } from "react";

export default function useNavItems() {
    const { isAuthenticated, isManager, isAdmin, logout } = useAuth();

    const mainNav: NavItem[] = useMemo(() => {
        if (!isAuthenticated) {
            return [{ title: "Login", path: "/account/login" }];
        }

        let routes = [
            { title: "Time/Expense", path: "/entry/time" },
            { title: "Snapshot", path: "/entry/snapshot" },
        ];

        if (isManager || isAdmin) {
            routes = [
                ...routes,
                { title: "Invoicing", path: "/invoice/" },
                { title: "Clients", path: "/client/" },
                { title: "Assignments", path: "/assignment/" },
                { title: "Staff", path: "/staff/" },
            ];
        }

        if (isAdmin) {
            routes = [...routes, { title: "Admin", path: "/admin/" }, { title: "Reporting", path: "/reporting/" }];
        }

        return routes;
    }, [isAuthenticated, isManager, isAdmin]);

    const userNav: NavItem[] = useMemo(
        () => [
            { title: "Edit Profile", path: "/account/profile", icon: <PersonIcon /> },
            { title: "Change Password", path: "/account/change-password", icon: <PasswordIcon /> },
            {
                title: "Logout",
                onClick: logout,
                path: "/account/login",
                icon: <LogoutIcon />,
            },
        ],
        [],
    );

    return {
        mainNav,
        userNav,
    };
}
